import { mapGetters } from 'vuex';
import moment from "moment";

export default {
  data: () => ({
    summaryItems: []
  }),
  computed: {
    ...mapGetters({
      mileage: "eviction/mileage",
      case: "eviction/currentCase",
      orders: "eviction/orders"
    }),
    getSummaryTotal() {
      const total = this.summaryItems.reduce((sum, item) => sum + item.total, 0);
      return Number(total);
    },
  },
  methods: {
    initFeeData(caseData = this.currentCase) {
      this.summaryItems = [];

      this.summaryItems = [
        {
          name: "Past Due Rent",
          total: 0,
          amounts: [],
          keys: ["pastDueRent"],
        },
      ]

      if (caseData.additionalChargesPermitted) {
        this.summaryItems.push({
          name: "Additional Charges",
          total: 0,
          amounts: [],
          keys: ["utilities", "fees", "otherCharges", "lateCharges"],
        })
      }

      if (caseData.legalFeesPermitted) {
        this.summaryItems.push({
          name: "Court Fees",
          total: 0,
          amounts: [],
          keys: ["legalFees"],
        });
      }

      if (caseData.pastDueRent.length) {
        this.summaryItems[0].amounts = caseData.pastDueRent.filter(value => value.selected);
        this.summaryItems[0].total = this.calculateTotal(caseData.pastDueRent);
      }

      if (caseData.additionalChargesPermitted) {
        this.summaryItems[1].amounts = [
          ...caseData.utilities,
          ...caseData.fees,
          ...caseData.otherCharges,
          ...caseData.lateCharges,
        ];
        this.summaryItems[1].total = this.calculateAdditionalChargeTotal();
      }

      if (caseData.legalFeesPermitted && caseData.section8 !== 1) {
        this.calculateCourtFees(caseData).then(data => {
          if (!caseData.additionalChargesPermitted) {
            this.summaryItems[1].amounts = data;
            this.summaryItems[1].total = this.calculateTotal(data);
          } else {
            this.summaryItems[2].amounts = data;
            this.summaryItems[2].total = this.calculateTotal(data);
          }
        })
      }
    },
    async calculateCourtFees(caseData) {
      if (!caseData.tenants.length) return null;

      if (!caseData.property || typeof caseData.property.county === "undefined") return null;

      const calculateTenantFee = 5 * caseData.tenants.length;
      const getCurrentCaseCounty = caseData.property.county.trim();

      if (typeof this.mileage.areas === "undefined") {
        await this.$store.dispatch('eviction/loadMileage');
      }

      const getMileageData = this.mileage.areas?.find(item => {
        if (caseData.mileageNeighborhood) {
          return item.county.trim() === getCurrentCaseCounty && item.neighborhood.trim() === caseData.mileageNeighborhood.trim()
        }
      });

      let calculateMileageFee = "";

      if (getMileageData) {
        calculateMileageFee = getMileageData.mileage;

        if (caseData.mileageAnswer) {
          calculateMileageFee = getMileageData.mileage + getMileageData.additional_fee;
        }
      }

      return [
        {
          type: "Filing Fee",
          amount: "50.00",
          selected: caseData.legalFeesPermitted,
        },
        {
          type: "Tenant Fee",
          amount: parseFloat(calculateTenantFee).toFixed(2),
          selected: caseData.legalFeesPermitted,
        },
        {
          type: "Mileage Fee",
          amount: parseFloat(calculateMileageFee).toFixed(2),
          selected: caseData.legalFeesPermitted,
        }
      ]
    },
    async saveLegalFees(caseData, submitted = false, lastStep = null) {
      const data = await this.calculateCourtFees(caseData);

      if (!data) return;

      if (!this.$store.getters.isAuthenticated) {
        const storageCase = localStorage.getItem("case")
        const caseInfo = {
          ...JSON.parse(storageCase),
          legalFees: data,
          statusDate: this.$dayjs().format("MM.DD.YY"),
        }
        const updatedCase = {
          ...caseInfo,
          status: null,
          submitted: false,
        }

        localStorage.setItem("case", JSON.stringify(updatedCase));

        return;
      }

      this.$http.post(`${process.env.VUE_APP_URL}/case/${caseData.id}`, {
        caseInfo: {
          ...caseData,
          legalFees: data,
          statusDate: moment().format("MM.DD.YY"),
        },
        clientId: this.$store.getters.client.id,
        submitted,
        status: submitted ? "Verified Complaint Complete" : (this.orders.indexOf(lastStep) > this.orders.indexOf(caseData.status) ? lastStep : caseData.status),
      })
    },
    calculateTotal(arr) {
      let total = 0;
      arr
        .filter(value => value.selected)
        .forEach((item) => {
          if (item.amount) {
            total += parseFloat(item.amount);
          }
        });
      return total;
    },
    calculateAdditionalChargeTotal() {
      return (
        this.calculateTotal(this.case.lateCharges) +
        this.calculateTotal(this.case.utilities) +
        this.calculateTotal(this.case.fees) +
        this.calculateTotal(this.case.otherCharges)
      );
    },
  }
}